
import api from "@/api";
import { defineComponent } from "vue";
export default defineComponent({
  name: "App",
  async created() {
    try {
      const response = await api.authenticate();
      console.log(response, 'resp');
      this.$store.commit('set_status', response.data.status)
      this.$store.commit('set_paid', response.data.paid)

      this.$store.commit('set_prompts', response.data.prompts)
      this.$store.commit('set_email', response.data.email)

      this.$router.push('sources')
    } catch (error) {
      this.$router.push('login')
      console.log(error, 'error');
    }
  }
});
